import React from 'react';
import XMLViewer from 'react-xml-viewer';
import { Visibility } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, IconButton } from '@totalsoft/rocket-ui';
import PropTypes from 'prop-types';

const GenericFilterParamLogXmlContentComponent = ({ onPopUpChange, openPopUp, data, loading }) => {
  const { t } = useTranslation();

  return (
    <>
      <IconButton id='xml-view-button' size='small' variant='text' onClick={onPopUpChange(openPopUp)}>
        <Visibility />
      </IconButton>
      {openPopUp && (
        <Dialog
          onClose={onPopUpChange(openPopUp)}
          open={openPopUp}
          title={t('GenericFilterParamLogs.XmlContents')}
          content={!loading && <XMLViewer xml={data?.genericFilterParamLogXmlContent?.xmlContents} />}
          actions={
            <Button variant='outlined' onClick={onPopUpChange(openPopUp)}>
              {t('GenericFilterParamLogs.ClosePopUp')}
            </Button>
          }
        />
      )}
    </>
  );
};

GenericFilterParamLogXmlContentComponent.propTypes = {
  onPopUpChange: PropTypes.func.isRequired,
  openPopUp: PropTypes.bool.isRequired,
  data: PropTypes.object,
  loading: PropTypes.bool.isRequired
};

export default GenericFilterParamLogXmlContentComponent;
